import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { Entity, isApiEntity } from '@backstage/catalog-model';

const SCALAR_FLAG = 'api-docs-scalar';

const isOpenApi = (entity: Entity) =>
  isApiEntity(entity) && entity.spec.type === 'openapi';

/**
 * A Scalar tab beside the plugin's own Definition tab (Swagger UI), which is
 * left untouched. Only an `openapi` entity gets it, in the same group so the
 * two sit next to each other. It is a tab of its own rather than a widget
 * inside the Definition card: the card's `overflow: hidden` breaks Scalar's
 * sticky sidebar, and at card width it drops the examples column under the
 * text. Behind a feature flag, per user in Settings → Feature Flags: the
 * predicate drops the tab altogether when the flag is off.
 */
const scalarContent = EntityContentBlueprint.make({
  name: 'scalar',
  if: { featureFlags: { $contains: SCALAR_FLAG } },
  params: {
    path: '/scalar',
    title: 'Scalar',
    group: 'documentation',
    filter: isOpenApi,
    loader: () => import('./ScalarContent').then(m => <m.ScalarContent />),
  },
});

export const apiDocsModule = createFrontendModule({
  pluginId: 'api-docs',
  extensions: [scalarContent],
  featureFlags: [
    {
      name: SCALAR_FLAG,
      description: 'Show OpenAPI definitions with Scalar, in a tab of its own',
    },
  ],
});
